import { render, staticRenderFns } from "./VuesticTreeRoot.vue?vue&type=template&id=48aa02b8"
import script from "./VuesticTreeRoot.vue?vue&type=script&lang=js"
export * from "./VuesticTreeRoot.vue?vue&type=script&lang=js"
import style0 from "./VuesticTreeRoot.vue?vue&type=style&index=0&id=48aa02b8&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48aa02b8')) {
      api.createRecord('48aa02b8', component.options)
    } else {
      api.reload('48aa02b8', component.options)
    }
    module.hot.accept("./VuesticTreeRoot.vue?vue&type=template&id=48aa02b8", function () {
      api.rerender('48aa02b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-tree-view/VuesticTreeRoot.vue"
export default component.exports